/* eslint-disable react/no-children-prop */
import { matchSorter } from 'match-sorter';
import React, { useState } from 'react';
import { Heading, Text, Checkbox, Shelf, Stack, Input, TextLink } from '@chaser/components';
import CardSection from '../../../../components/CardSection';
import useNotifications from '../../../../hooks/useNotifications';

const labels = {
  invoice_history_reminders: 'Reminders on notes',
  invoice_history_mentions: 'Mentions on notes',
  invoice_thresholds: 'When credit limit is hit',
  csv_failure: 'When CSV upload fails',
  portal_payment_success: 'Chaser Pay payment notifications',
  early_discount_fees: 'When early payment discount is applied',
  late_payment_fees: 'When late payment fees are applied',
};

const Notifications = () => {
  const [searchValue, setSearchValue] = useState('');
  const {
    data,
    applyOptimisticUpdate,
    executeUpdateSetting,
    executeUpdateAll,
  } = useNotifications();

  async function updateSetting(shortCode, type, email) {
    await applyOptimisticUpdate(state => {
      const item = state.notificationsSettings.find(i => i.organisation.ShortCode === shortCode);
      const notification = item.configuration.find(i => i.type === type);
      notification.email = email;
      notification._isOptimistic = true;
    }, executeUpdateSetting({ shortCode, type, email }));
  }

  async function updateAll(enable) {
    await applyOptimisticUpdate(state => {
      state.notificationsSettings.forEach(item => {
        item.configuration.forEach(notification => {
          notification._isOptimistic = notification.email !== enable;
          notification.email = enable;
        });
      });
    }, executeUpdateAll(enable));
  }

  const items = data.notificationsSettings
    ? matchSorter(data.notificationsSettings, searchValue, {
        keys: ['organisation.name'],
      })
    : [];

  const areAllEnabled = data.notificationsSettings?.every(item =>
    item.configuration.every(notification => notification.email),
  );

  return (
    <Stack gap="medium">
      <Shelf
        gap="small"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
      >
        <Text color="Mid Neutral 1">
          Choose which <Text color="Dark Neutral 1">email notifications</Text> you want to
          receive.&nbsp;{' '}
          {items.length > 0 && (
            <TextLink
              color="Dark Neutral 1"
              monochrome
              as="button"
              type="button"
              onClick={() => updateAll(!areAllEnabled)}
            >
              {areAllEnabled ? 'Disable' : 'Enable'} all
            </TextLink>
          )}
        </Text>
        {data.notificationsSettings?.length > 9 && (
          <Input
            width="full"
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            icon="search"
            placeholder="Search organisation"
          />
        )}
      </Shelf>
      {items.length > 0 ? (
        <Stack>
          {items.map(item => (
            <CardSection title={item.organisation.name}>
              <Stack gap="xsmall" style={{ lineHeight: 1 }}>
                {item.configuration.map(notification => (
                  <div>
                    <Checkbox
                      checked={notification.email}
                      onChange={e => {
                        updateSetting(
                          item.organisation.ShortCode,
                          notification.type,
                          e.target.checked,
                        );
                      }}
                      disabled={notification._isOptimistic}
                    >
                      {labels[notification.type]}
                    </Checkbox>
                  </div>
                ))}
              </Stack>
            </CardSection>
          ))}
        </Stack>
      ) : (
        <div>
          <Heading as="h3" fontSize="heading.3" fontWeight="bold">
            No organisations
          </Heading>
        </div>
      )}
    </Stack>
  );
};

export default Notifications;
